var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "white",
    stroke: "#DBDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5C10.5 18.9547 10.5572 19.1897 10.6208 19.3199C10.666 19.4123 10.7397 19.5091 10.9653 19.6117C11.2237 19.7291 11.6435 19.8346 12.3304 19.904C13.0076 19.9724 13.8776 20 15 20C16.1224 20 16.9924 19.9724 17.6696 19.904C18.3565 19.8346 18.7763 19.7291 19.0347 19.6117C19.2603 19.5091 19.334 19.4123 19.3792 19.3199C19.4428 19.1897 19.5 18.9547 19.5 18.5C19.5 18.0453 19.4428 17.8103 19.3792 17.6801C19.334 17.5877 19.2603 17.4909 19.0347 17.3883C18.7763 17.2709 18.3565 17.1654 17.6696 17.0961C16.9924 17.0276 16.1224 17 15 17C13.8776 17 13.0076 17.0276 12.3304 17.0961C11.6435 17.1654 11.2237 17.2709 10.9653 17.3883C10.7397 17.4909 10.666 17.5877 10.6208 17.6801C10.5572 17.8103 10.5 18.0453 10.5 18.5Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12C13 13.1046 13.8954 14 15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12Z",
    stroke: "#222222",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/userImg.1673786fdcc75dcd5a4ec5bbd5ee2781.svg";
export { ForwardRef as ReactComponent };